import React from 'react';
import { Link } from 'react-router-dom';
import AppsLayout from './AppsLayout';
import Reveal from './components/Reveal';
import SpotlightCard from './components/SpotlightCard';
import Badge from './components/Badge';
import Button from './components/Button';
import GooglePlayBadge from './components/GooglePlayBadge';
import { apps } from '../../content/apps';
import { trackClick } from '../../firebase/analytics';
import { APPS_ROUTES } from './routes';

const PAGE = 'apps';

export default function AppsPage() {
  return (
    <AppsLayout
      title="Portfolio · Keval Langalia"
      description="Apps, web apps and other projects by Keval Langalia, including Birdify, NumbCrunch and a browser-based QR code generator."
      canonicalPath={APPS_ROUTES.apps}
      breadcrumbs={[{ label: 'Portfolio' }]}
      page={PAGE}
    >
      <Reveal as="section" className="apps-hero" aria-labelledby="apps-heading">
        <p className="apps-eyebrow">Portfolio</p>
        <h1 id="apps-heading" className="apps-title">Things I build outside of work</h1>
        <p className="apps-lead">
          Apps, web apps and other projects I build to explore ideas and solve everyday problems. Each project has its own page with details about what it does and how it handles your privacy.
        </p>
      </Reveal>

      <section className="apps-section" aria-labelledby="apps-collection-heading">
        <h2 id="apps-collection-heading" className="apps-section-title">Collection</h2>
        <p className="apps-muted">A growing collection of Android apps and browser-based tools.</p>
        <ul className="apps-grid">
          {apps.map((app, index) => (
            <Reveal as="li" key={app.id} delay={index * 80}>
              <SpotlightCard as="article" aria-labelledby={`app-${app.id}-title`}>
                <div className="apps-card-icon" aria-hidden="true">
                  {app.iconImage ? <img src={app.iconImage} width="48" height="48" alt="" /> : <i className={app.icon}></i>}
                </div>
                <h2 id={`app-${app.id}-title`}>
                  <Link to={app.route} onClick={trackClick(PAGE, `${app.id}_card_title_link`)}>{app.name}</Link>
                </h2>
                <p><strong>{app.tagline}</strong></p>
                <p>{app.summary}</p>
                {app.badges.length > 0 || app.release.label ? (
                  <ul className="apps-badges" aria-label={`${app.name} details`}>
                    {app.badges.map((badge) => (
                      <li key={badge.label}><Badge variant={badge.variant}>{badge.label}</Badge></li>
                    ))}
                    {app.release.label ? <li><Badge variant="status">{app.release.label}</Badge></li> : null}
                  </ul>
                ) : null}
                <div className="apps-card-actions">
                  <Button to={app.route} onClick={trackClick(PAGE, `${app.id}_details_button`)}>
                    About {app.name}
                  </Button>
                  {app.release.playStoreUrl ? (
                    <GooglePlayBadge
                      href={app.release.playStoreUrl}
                      appName={app.name}
                      size="card"
                      onClick={trackClick(PAGE, `${app.id}_google_play_button`)}
                    />
                  ) : null}
                  {app.privacyRoute && app.cardPrivacyLink !== false ? (
                    <Button to={app.privacyRoute} variant="ghost" onClick={trackClick(PAGE, `${app.id}_privacy_link`)}>
                      Privacy policy
                    </Button>
                  ) : null}
                </div>
              </SpotlightCard>
            </Reveal>
          ))}
        </ul>
      </section>
    </AppsLayout>
  );
}
